<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="3%")
          span #
        th(width="5%")
          span(:title="$t('ui.id')") {{ $t('ui.id') }}
        th(width="5%")
          span(:title="$t('ui.ref_no')") {{ $t('ui.ref_no') }}
        th(width="8%")
          span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
        th(width="8%")
          span(:title="$t('ui.member')") {{ $t('ui.member') }}
        th.text-right(width="7%")
          span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
        th(width="8%")
          span(:title="$t('ui.sender_bank_acc_no')") {{ $t('ui.short.sender_bank_acc_no') }}
        th(width="7%")
          span(:title="$t('ui.recipient_bank_id')") {{ $t('ui.short.recipient_bank_id') }}
        th(width="10%")
          span(:title="$t('ui.recipient_bank_acc_no')") {{ $t("ui.short.recipient_bank_acc_no") }}
        th.text-center(width="8%")
          span(:title="$t('ui.status')") {{ $t("ui.status") }}
        th(width="16%")
          span(:title="$t('ui.remark')") {{ $t("ui.remark") }}
        th(width="8%")
          span(:title="$t('ui.created_by')") {{ $t("ui.created_by") }}
        th.text-right(width="10%")
          span(:title="$t('ui.approve_time')") {{ $t("ui.approve_time") }}
        th.text-right(width="10%")
          span(:title="$t('ui.audit_time_created')") {{ $t("ui.audit_time_created") }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(colspan="14").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl" :class="$helpers.rowClassTicket(item, 'withdrawal')")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td
          span.d-block(:title="item.id") {{ item.id }}&nbsp;
        td
          span.small.text-info.d-block(:title="getRefNo(item.sender_bank_id, item.id, item.prefix_w, item.prefix_delimiter)") {{ getRefNo(item.sender_bank_id, item.id, item.prefix_w, item.prefix_delimiter) }}&nbsp;
        td
          span(:title="item.parent_id") {{ item.parent_id }}&nbsp;
        td
          span.font-weight-bold(:title="item.member_id")
            b-link.clickable(href="javascript:void(0);" @click="onInfo(item)") {{ item.member_id }}&nbsp;
        td.text-right
          span.font-weight-bold.d-block(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
        td
          span(:title="item.sender_bank_acc_no") {{ item.sender_bank_acc_no }}&nbsp;
        td
          span(:title="item.recipient_bank_id") {{ item.recipient_bank_id }}&nbsp;
        td
          span(:title="item.recipient_bank_acc_no") {{ item.recipient_bank_acc_no }}&nbsp;
        td.text-center
          span(:class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}&nbsp;
        td
          span(:title="item.remark") {{ item.remark }}&nbsp;
        td
          span(:title="item.created_by") {{ item.created_by }}&nbsp;
        td.text-right
          span(v-if="item.modified_date" :title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') }}
        td.text-right
          span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
    ticketStatus: {
      type: String,
      default: ""
    },
  },
  methods: {
    getRefNo: function(bank_id, id, prefix, delimiter) {
      return this.$helpers.getPaymentGatewayRefNoSetMember(bank_id, id, prefix, delimiter);
    },
  }
};
</script>
